<script lang="ts" setup>
import './favorite.scss';
import type { Performer } from '@/ontology/performer';
import { computed, ref } from 'vue';
import { usePerformerStore } from '@/stores/performer';

const props = defineProps<{ id: number }>();

const { isFavorite, toggleFavorite } = usePerformerStore();
const toggling = ref(false);

async function toggle() {
    if (toggling.value) return;
    toggling.value = true;
    await toggleFavorite(props.id);
    toggling.value = false;
}
</script>

<template src="./favorite.html"></template>